import { RDCarouselDataComponent } from './carousel-data/carousel-data.component';
import { Component, OnInit, QueryList, ContentChildren, AfterViewInit, Input, OnChanges,
  Output, EventEmitter } from '@angular/core';
import { trigger, transition, query, animate, keyframes, style, group } from '@angular/animations';
import 'hammerjs';

@Component({
  selector: 'rd-carousel',
  template: `<div class="carouselWrapper">
  <div class="dataContainer" [@carouselAnimation]="change" [style.height.px]="height"
  (swipeLeft)="changeDisplay(1, 'next')" (swipeRight)="changeDisplay(-1, 'prev')">
    <ng-content></ng-content>
  </div>

  <div class="arrow leftArrow" (click)="changeDisplayByClick($event, -1, 'prev')">
    <span><i class="fas fa-chevron-left fa-2x"></i></span>
  </div>

  <div class="arrow rightArrow" (click)="changeDisplayByClick($event, 1, 'next')">
    <span><i class="fas fa-chevron-right fa-2x"></i></span>
  </div>

  <div class="stepper">
    <div class="step" *ngFor="let i of carouselLength" [class.active]="i === displayedIndex"
    (click)="changeStep($event, i)">
    </div>
  </div>
</div>
`,
  styles: [`.carouselWrapper{width:100%;position:relative}.carouselWrapper .dataContainer{width:100%;position:relative;overflow:hidden}.carouselWrapper .arrow{position:absolute;top:50%;left:0;z-index:2;-webkit-transform:translateY(-50%);transform:translateY(-50%);padding:18px 12px;color:#e3e3e3;background-color:rgba(64,64,64,.5);cursor:pointer}.carouselWrapper .arrow.rightArrow{left:auto;right:0}.carouselWrapper .arrow:hover{color:#fff}.carouselWrapper .stepper{position:absolute;bottom:5%;left:50%;z-index:2;-webkit-transform:translateX(-50%);transform:translateX(-50%);display:flex;flex-direction:row}.carouselWrapper .stepper .step{width:5px;height:5px;border:1px solid #e3e3e3;border-radius:50%;margin:3px;background-color:transparent;cursor:pointer}.carouselWrapper .stepper .step.active{background-color:#e3e3e3}`],
  animations: [
    trigger('carouselAnimation', [
      transition('* => prev', [
        group([query(':enter', animate('.5s linear', keyframes([
            style({transform: 'translateX(100%)', offset: 0}),
            style({transform: 'translateX(0)', offset: 1.0}),
          ])), {optional: true}),
        query(':leave', animate('.5s linear', keyframes([
            style({ offset: 0}),
            style({transform: 'translateX(-100%)', offset: 1.0}),
          ])), {optional: true})])
      ]),
      transition('* => next', [
        group([query(':enter', animate('.5s linear', keyframes([
            style({transform: 'translateX(-100%)', offset: 0}),
            style({transform: 'translateX(0)', offset: 1.0}),
          ])), {optional: true}),
        query(':leave', animate('.5s linear', keyframes([
            style({offset: 0}),
            style({transform: 'translateX(100%)', offset: 1.0}),
          ])), {optional: true})])
      ])
    ])
  ]
})
export class RDCarouselComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() height = 250;
  @Input() timer = 3000;
  @Input() displayedIndex = 0;

  @Output() displayedIndexChange: EventEmitter<any> = new EventEmitter();

  @ContentChildren(RDCarouselDataComponent) carousels: QueryList<RDCarouselDataComponent>;

  public change = null;
  public timeout = null;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    if (this.carousels && changes.displayedIndex) {
      if (changes.displayedIndex.currentValue < changes.displayedIndex.previousValue) {
        this.change = 'next';
      } else if (changes.displayedIndex.currentValue > changes.displayedIndex.previousValue) {
        this.change = 'prev';
      }
      this.changeView();
    }
  }

  ngAfterViewInit() {
    this.changeView();
  }

  changeDisplayByClick(event, value, change) {
    event.stopPropagation();
    this.changeDisplay(value, change);
  }

  changeDisplay(value, change) {
    this.change = change;
    this.displayedIndex = (this.displayedIndex + value) < 0 ? this.carousels.length - 1
    : (this.displayedIndex + value) % this.carousels.length;
    this.displayedIndexChange.emit(this.displayedIndex);
    this.changeView();
  }

  changeStep(event, index) {
    if (index < this.displayedIndex) {
      this.change = 'next';
    } else if (index > this.displayedIndex) {
      this.change = 'prev';
    }
    this.displayedIndex = index;
    this.changeView();
  }

  changeView() {
    clearTimeout(this.timeout);
    this.carousels.forEach((carousel, index) => {
      if (carousel.displayed === true && index !== this.displayedIndex) {
        Promise.resolve(null).then(() => carousel.displayed = false);
        carousel.displayChange.emit({index: index, state: false});
      }
    });
    this.carousels.forEach((carousel, index) => {
      if (index === this.displayedIndex) {
        Promise.resolve(null).then(() => carousel.displayed = true);
        carousel.displayChange.emit({index: index, state: true});
      }
    });
    setTimeout(() => {
      this.change = null;
    }, 500);
    if (this.timer !== null) {
      this.timeout = setTimeout(() => {
        this.changeDisplay(1, 'next');
      }, this.timer);
    }
  }

  get carouselLength() {
    const length = [];
    for (let i = 0; i < this.carousels.length; i++) {
      length.push(i);
    }
    return length;
  }

}
